import React, { useState } from "react";
import axios from "axios";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

const AddGroupModal = ({ show, handleClose, mandalId, handleGroupAdded }) => {
  const apiURL = process.env.REACT_APP_API_URL;

  // Separate state variables
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [surName, setSurName] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const [loading, setLoading] = useState(false);

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "firstName") setFirstName(value);
    else if (name === "lastName") setLastName(value);
    else if (name === "surName") setSurName(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${apiURL}/SamparkEmploye/Create`,
        {},
        {
          params: {
            MandalDetailsId: mandalId,
            FirstName: firstName,
            LastName: lastName,
            SurName: surName,
            IsVisible: isVisible,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.status) {
        toast.success(response.data.message);
        handleGroupAdded(response.data.data);
        handleClose();
      } else {
        toast.error(response.data.message || "Failed to add group!");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`modal fade ${show ? "show" : ""}`} style={{ display: show ? "block" : "none" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Group</h5>
            <button type="button" className="btn btn-danger" onClick={handleClose}>
              <FaTimes size={20} />
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="text-left d-block">Firstname</label>
                <input
                  type="text"
                  name="firstName"
                  className="form-control"
                  value={firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="text-left d-block">Lastname</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-control"
                  value={lastName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="text-left d-block">Surname</label>
                <input
                  type="text"
                  name="surName"
                  className="form-control"
                  value={surName}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Adding..." : "Add Group"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGroupModal;
